import React from 'react';
import { Button } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TutorPart from './TutorPart';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import SectionIntro from '../../../molecules/SectionIntro';
import { useRouter } from 'next/router';
import appUtils from '../../../../utils/appUtils';

const HomeOurTutors = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { locale } = router;
  return (
    <section className="bg-[#fbe4dc]/40 py-16 md:py-24">
      <div id="meet-our-tutors-container">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-5xl lg:px-8">
          <SectionIntro
            title={t('service.home.meetTutors.title')}
            intro={t('service.home.meetTutors.intro')}
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <TutorPart
              name="Hazel Cobol"
              photoUrl="/images/hazel.jpg"
              description={t('service.home.meetTutors.hazel')}
            />
            <TutorPart
              name="Ceferina Abulencia"
              photoUrl="/images/cef.jpg"
              description={t('service.home.meetTutors.cef')}
            />
            <TutorPart
              name="Janice Valestra"
              photoUrl="/images/janice.jpg"
              description={t('service.home.meetTutors.janice')}
            />
          </div>
          <div className="text-center mt-12 pb-8">
            <a href={appUtils.getAppPath(locale, 'tutors')}>
              <Button
                size="lg"
                variant="outline"
                className="border-[#1c1c1c] text-[#1c1c1c] hover:bg-[#1c1c1c] hover:text-white transition-colors px-6"
              >
                <span>{t('links.browseTutors')}</span>
                <ArrowRightIcon className="h-4 w-4 ml-2" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default HomeOurTutors;
